module.exports = __webpack_public_path__ + "static/img/user10.cd79096.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user10.jpg
// module id = FNcY
// module chunks = 23